<template>
  <div class="form-group"
    :class="{'is-invalid-group':error || errorMessage}"
  >
    <div class="textOnInput">
      <label class="form-control-label" :for="name">{{ label }}</label>
<!-- 
      <div class="input-group input-group-merge">
        <div class="input-group-prepend" v-if="icon">
          <span class="input-group-text">
            <feather :type="icon" class="icon-dual"></feather>
          </span>
        </div> -->

        <b-form-select 
          :class="{ 'is-invalid': error || errorMessage, 'is-valid': !error && !errorMessage && isSelected }"
          :placeholder="placeholder"
          @input="onInput($event)"
          :options='options'
          :value="value"
          @change="onChange($event)"
        ></b-form-select>
      <!-- </div> -->
    </div>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="invalid-feedback" v-else-if="error">
      Please provide a valid {{ name || label || 'input' }}
    </div>
    <div class="text-success" v-else-if="!error && !errorMessage && isSelected">
      Looks good!
    </div>
    <div class="text-muted" v-if="help">
      {{ help }}
    </div>
    <!-- <ul 
        class="parsley-errors-list filled" 
        v-if="error"
      >
      <li>
          <div v-if="!required">This value is required.</div>
          <div v-if="!email">This value should be a valid email.</div>
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  props:[
    'type', 
    'placeholder', 
    'label', 
    'icon', 
    'name', 
    'autocomplete', 
    'value', 
    'required', 
    'error', 
    'errorMessage', 
    'help', 
    'options'
  ],
  data() {
    return {
      isSelected: false
    }
  },
  methods: {
    onInput(val) {
      this.isSelected = false
      this.$emit('update:name', val)

      // if(val) {
      //   this.isSelected = true
      // }
    },
    onChange(val) {
      this.isSelected = false
      this.$emit('change', val)

      // if(val) {
      //   this.isSelected = true
      // }
    }
  }
}
</script>
<style>
  /* b-form-select:is-valid {
    border: 1px solid #2dc28c !important;
    content: "✓";
  }

  b-form-select:is-invalid {
    border: 1px solid #ff5c75 !important;
  } */
</style>